/**
 * @param {number} - openingYear like 2020
 * @param {number} - designYear like 2040
 * @returns {object} - returns an object with the discount factor for each year starting from openingYear to designYear
 */

const getDiscountFactors = (openingYear, designYear, discountRate) => {
  let discountFactor = {};
  // calculates discount factor for each year
  for (let year = openingYear; year <= designYear; year++) {
    discountFactor[year] = 1 / Math.pow(1 + discountRate, year - openingYear);
  }
  return discountFactor;
};
/**
 * @param {number} - openingYear
 * @param {number} - calculationYear
 * @param {object} - has two keys 1. cost and 2. periodYears
 * @returns {number} - a cost value based on the openingYear, calculation year, period of maintenance
 */

const calculateIndividualCosts = (
  openingYear,
  operationsMaintenanceSplit,
  calculationYear
) => {
  if (calculationYear < openingYear) {
    throw new Error(
      "Calculation year is less than the base year, check inputs"
    );
  } else if (
    (calculationYear - openingYear) % operationsMaintenanceSplit.periodYears ===
    0
  ) {
    return operationsMaintenanceSplit.cost;
  } else {
    return 0;
  }
};

/**
 *These are Inputs for the cost calculations (some sample values are given below)
 * @param {number} openingYear  //Page 2
 * @param {number} designYear //Page 2
 * @param {number} discountRate  //Page 6
 * @param operationsMaintenanceCostsPeriod = {
      signalRetiming: {cost: {number}, periodYears: {number}},
      power: {cost: {number}, periodYears: {number}},
      lighting: {cost: {number}, periodYears: {number}},
      signalMaintenance: {cost: {number}, periodYears: {number}},
      roundaboutLandscaping: {cost: {number}, periodYears: {number}},
      other: {cost: {number}, periodYears: {number}},
      other2: {cost: {number}, periodYears: {number}}} //Page 6
  * @returns {number} - operations Maintenance cost
*/

export const getOperationsMaintenanceCostsTotal = ({
  openingYear,
  designYear,
  discountRate = window.PENN_DOT_CONSTANTS.DISCOUNT_RATE,
  operationsMaintenanceCostsPeriod,
}) => {
  const discountFactor = getDiscountFactors(
    openingYear,
    designYear,
    discountRate
  );

  const operationsMaintenanceCosts = {};
  Object.keys(operationsMaintenanceCostsPeriod).forEach((element) => {
    operationsMaintenanceCosts[element] = {};
    // calculates the individual operations maintenance costs for each year
    for (let year = openingYear; year <= designYear; year++) {
      operationsMaintenanceCosts[element][year] = calculateIndividualCosts(
        openingYear,
        operationsMaintenanceCostsPeriod[element],
        year
      );
    }
  });

  const operationsMaintenanceCostsYearly = {};
  // aggregates operations maintenance costs for each year
  for (let year = openingYear; year <= designYear; year++) {
    let sum = 0;
    Object.keys(operationsMaintenanceCostsPeriod).forEach((element) => {
      sum += operationsMaintenanceCosts[element][year];
    });

    operationsMaintenanceCostsYearly[year] = sum;
  }

  let operationsMaintenanceCostsTotal = 0;
  // total operations maintenance costs
  for (let year = openingYear; year <= designYear; year++) {
    operationsMaintenanceCostsTotal +=
      discountFactor[year] * operationsMaintenanceCostsYearly[year];
  }
  return operationsMaintenanceCostsTotal;
};
